import '@swc/helpers';
import 'react';
import { useBrPageContext } from '../context/context.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';

const useBloomreachPageModels = ()=>{
    const page = useBrPageContext();
    return page === null || page === void 0 ? void 0 : page.getComponent().getModels();
};

export { useBloomreachPageModels };
//# sourceMappingURL=use-bloomreach-page-models.js.map
